import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import InputAdornment from "@mui/material/InputAdornment";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

// Iconos
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import BusinessIcon from "@mui/icons-material/Business";
import StorefrontIcon from "@mui/icons-material/Storefront";
import NotesIcon from "@mui/icons-material/Notes";
import ControlField from "./ControlField"
import FieldLabel from "./FieldLabel";
import FieldRemitos from "./FieldRemitos";

const BRAND = "#2471A3";

export default function ItemsFormulario({
  cliente,
  selectorSucursal,
  letra,
  itemsForm,
  handlePrecioChange,
  leyenda,
  setLeyenda,
  ocs,
  setOcs,
  remitosTexto,
}) {
  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 700, mb: 1, color: "text.secondary" }}
          >
            DETALLE DE PRODUCTOS A FACTURAR
          </Typography>
          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{ borderRadius: 2, overflow: "hidden" }}
          >
            <Table size="small">
              <TableHead sx={{ bgcolor: "action.hover" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Producto</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 700 }}>
                    Cantidad
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 700 }}>
                    U.M.
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 700 }}>
                    IVA (%)
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: 700, minWidth: 130 }}
                  >
                    P. Unit. SIN IVA
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: 700, minWidth: 130 }}
                  >
                    P. Unit. CON IVA
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ fontWeight: 700, minWidth: 120 }}
                  >
                    Total Item (Sin IVA)
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {itemsForm.map((row, index) => (
                  <TableRow key={row.id_producto || index} hover>
                    <TableCell sx={{ fontWeight: 600 }}>
                      {row.producto}
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body2" sx={{ fontWeight: 700 }}>
                        {row.cantidad_total ?? row.cantidad}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={row.nombre_um?.toUpperCase()}
                        size="small"
                        variant="outlined"
                        sx={{ fontWeight: 600, height: 20, fontSize: 11 }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      {row?.descripcion || row.iva || 0}%
                    </TableCell>
                    <TableCell align="center">
                      <TextField
                        size="small"
                        variant="standard"
                        value={row.precioSinIva}
                        focused
                        onChange={(e) =>
                          handlePrecioChange(
                            index,
                            "sinIva",
                            e.target.value
                          )
                        }
                        sx={{ width: 110 }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              $
                            </InputAdornment>
                          ),
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <TextField
                        size="small"
                        variant="standard"
                        value={row.precioConIva}
                        focused
                        onChange={(e) =>
                          handlePrecioChange(
                            index,
                            "conIva",
                            e.target.value
                          )
                        }
                        sx={{ width: 110 }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              $
                            </InputAdornment>
                          ),
                        }}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 700, color: "primary.main" }}
                      >
                        ${" "}
                        {Number(row.totalItem || 0).toLocaleString(
                          "es-AR",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

 
            <Grid item xs={12} sm={9}>
              <ControlField
                icon={<NotesIcon sx={{ fontSize: 16 }} />}
                label="Leyenda"
              >
                <TextField
                  fullWidth
                  multiline
                  minRows={1}
                  maxRows={3}
                  size="small"
                  variant="standard"
                  placeholder="Ingresá una leyenda para el comprobante"
                  value={leyenda}
                  onChange={(e) => setLeyenda(e.target.value)}
                  inputProps={{ maxLength: 250 }}
                />
              </ControlField>
            </Grid>

            <Grid item xs={12} sm={3}>
              <ControlField
                icon={<NotesIcon sx={{ fontSize: 16 }} />}
                label="OCS"
              >
                <TextField
                  fullWidth
                  multiline
                  minRows={1}
                  maxRows={3}
                  size="small"
                  variant="standard"
                  placeholder="Ordenes de compra"
                  value={ocs}
                  onChange={(e) => {
                    const regex = /[^0-9, ]/g;
                    const valueFiltrado = e.target.value.replace(regex, "");
                    setOcs(valueFiltrado);
                  }}
                  inputProps={{ maxLength: 250 }}
                  helperText="Texto tal cual saldrá en el comprobante."
                />
              </ControlField>
            </Grid>

      </Grid>
      <Divider sx={{ my: 2.5 }} />
      <FieldRemitos remitosTexto={remitosTexto} cliente={cliente} />
    </Box>
  )
}


